import React, { Component } from "react"
import { Button, Modal } from "react-bootstrap"
import dompurify from "dompurify"
import ReviewTimelineTypes from "../../ReviewTypes/ReviewTimelineTypes"
import "./ReviewTimelineViewer.css"

interface Props {
    openItem: ReviewTimelineTypes
    toggleReviewTimelineViewer: Function
}

class ReviewTimelineViewer extends Component<Props, {}> {

    render() {

        const openItem = this.props.openItem

        return (
            <div className="ReviewTimelineViewer">
                <Modal
                    show={true}
                    backdrop="static"
                    keyboard={true}
                    centered={true}
                    size="xl"
                >
                    <Modal.Header>
                        <div className="ReviewTimelineViewerModalHeader">
                            <p><p id="review-timeline-viewer-modal-header-left">Viewing:</p> {openItem.TimelineTitle}</p>
                            {openItem.EmployeeReviewTimelineTypeDesc === "correspondence" && <span className="material-icons">email</span>}
                            {openItem.EmployeeReviewTimelineTypeDesc === "note" && <span className="material-icons">chat</span>}
                            {openItem.EmployeeReviewTimelineTypeDesc === "event" && <span className="material-icons">event</span>}
                        </div>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="ReviewTimelineViewerModalBody" dangerouslySetInnerHTML={{ __html: dompurify.sanitize(openItem.NoteText) }}></div>
                    </Modal.Body>
                    <Modal.Footer>
                        <div className="ReviewTimelineViewerModalFooter">
                            <Button variant="secondary" onClick={() => this.props.toggleReviewTimelineViewer()}>Back</Button>
                        </div>
                    </Modal.Footer>
                </Modal>
            </div>
        )
    }
}

export default ReviewTimelineViewer;